<template>
  <div :class="[$style.root, 'root']">
    <!-- <h4 class="text-capitalize mb-0">{{ composition.name }}</h4> -->

    <!-- <vue-perfect-scrollbar
      :class="[$style.rootScroller]"
      :settings="{
        maxScrollbarLength: 220,
        suppressScrollX: true,
      }"
    >
      <VirtualList
        data-key="ID"
        :data-sources="composition.options"
        :data-component="ProductCompositionThumbOption"
        :estimate-size="330"
        wrap-class="row"
        item-class="col-4 text-center mb-4"
        :extra-props="{}"
      > -->
    <!-- <v-virtual-scroll
      :items="composition.options"
      item-height="330"
      height="750"
    > -->
    <!-- <template v-slot:default="{ item }"> -->
    <!-- <ProductCompositionThumbOption
          :source="item"
          :class="classes"
          @onAdd="onZoom(item)"
          @onUpdate="$emit('updateOrder')"
        /> -->
    <!-- </template> -->
    <!-- </v-virtual-scroll> -->
    <!-- </VirtualList> -->
    <!-- </vue-perfect-scrollbar> -->

    <!-- <RecycleScroller
      :class="[$style.rootScroller]"
      :items="composition.options"
      :item-size="1"
      key-field="ID"
      page-mode
    >
      <template v-slot="{ item }">
        <ProductCompositionThumbOption
          :option="item"
          :class="classes"
          @onAdd="onZoom(item)"
          @onUpdate="$emit('updateOrder')"
        />
      </template>
    </RecycleScroller> -->

    <perfect-scrollbar
      :class="[$style.rootScroller]"
      :options="{
        maxScrollbarLength: 220,
        suppressScrollX: true,
      }"
    >
      <v-row>
        <v-col
          v-for="opt in items"
          :key="opt.ID"
          class="text-center mb-4"
          md="4"
        >
          <ProductCompositionThumbOption
            :source="opt"
            @onAdd="onZoom(opt)"
            @onUpdate="$emit('updateOrder')"
          />
        </v-col>
      </v-row>
    </perfect-scrollbar>

    <b-modal
      ref="modalZoom"
      v-if="currentOpt"
      :title="currentOpt.post_title"
      body-class="p-0"
      centered
    >
      <img
        :class="[$style.rootImageZoom, 'img-fluid']"
        :src="currentOpt.image"
        :alt="currentOpt.post_title"
        :title="currentOpt.post_title"
      />

      <template class="justify-content-between" #modal-footer="{ ok, cancel }">
        <div class="d-flex justify-content-between w-100">
          <b-button size="sm" variant="secondary" @click="cancel()">
            Cancelar
          </b-button>

          <div class="ml-auto mr-1">
            <b-form-input
              ref="quantityInput"
              v-model="quantity"
              type="number"
              min="1"
              placeholder="Cantidad"
              style="width: 100px"
            />
          </div>

          <b-button size="sm" variant="info" @click="onAdd(ok)">
            Agregar
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import VirtualList from 'vue-virtual-scroll-list'

import CompositionOrder from '@/models/compositionOrder.model'

import FormatHelper from '@/helpers/FormatHelper.js'
import ProductCompositionThumbOption from 'Components/composite-product/CompositeProductCompositionThumbOption'

@Component({
  components: {
    VirtualList,
    ProductCompositionThumbOption,
  },
})
export default class ProductCompositionThumbs extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  items

  ProductCompositionThumbOption = ProductCompositionThumbOption

  quantity = 1

  currentOpt = null

  busy = false

  loadMore() {
    this.busy = true

    setTimeout(() => {
      this.busy = false
    }, 100)
  }

  getFormatPrice(price) {
    return FormatHelper.formatCurrency(price)
  }

  onAdd(ok) {
    CompositionOrder.insert({
      data: {
        id: this.currentOpt.ID,
        name: this.currentOpt.post_title,
        data: { ...this.currentOpt },
        quantity: parseInt(this.quantity),
        price: this.currentOpt.price,
        isAdition: true,
      },
    })

    this.$emit('updateOrder')

    ok()
  }

  onZoom(opt) {
    this.currentOpt = opt.data
    this.quantity = 1

    this.$nextTick(() => {
      this.$refs.modalZoom.show()

      setTimeout(() => {
        this.$refs.quantityInput.focus()
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.root {
  /deep/ {
    .v-virtual-scroll__container {
      display: flex;
      flex-wrap: wrap;
      flex: 1 1 auto;
      margin: -12px;
    }

    .v-virtual-scroll__item {
      flex: 0 0 33.3333333333%;
      max-width: 33.3333333333%;
      width: 100%;
      padding: 12px;
      text-align: center;
    }
  }
}
/* /deep/ .vue-recycle-scroller__item-wrapper {
  display: flex;
  flex-wrap: wrap;
  height: 800px;
  overflow-y: auto;
  margin-right: -15px;
  margin-left: -15px;

  .vue-recycle-scroller__item-view {
    flex: 0 0 33.333333%;
    margin-bottom: 1.5rem;
    max-width: 33.333333%;
    padding-right: 15px;
    padding-left: 15px;
    position: relative;
    text-align: center;
    width: 100%;
  }
} */
</style>

<style lang="scss" module>
.root {
  &--Scroller {
    max-height: 750px;
  }
}
</style>
